/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Action_Cna_SuccessInputs */

const en_ticket_action_cna_success = /** @type {(inputs: Ticket_Action_Cna_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logged: customer not reachable.`)
};

const ja_ticket_action_cna_success = /** @type {(inputs: Ticket_Action_Cna_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`記録: 顧客に連絡が取れない。`)
};

const fr_ticket_action_cna_success = /** @type {(inputs: Ticket_Action_Cna_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistré : client injoignable.`)
};

const de_ticket_action_cna_success = /** @type {(inputs: Ticket_Action_Cna_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfasst: Kunde nicht erreichbar.`)
};

/**
* | output |
* | --- |
* | "Logged: customer not reachable." |
*
* @param {Ticket_Action_Cna_SuccessInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_action_cna_success = /** @type {((inputs?: Ticket_Action_Cna_SuccessInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Action_Cna_SuccessInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_action_cna_success(inputs)
	if (locale === "ja") return ja_ticket_action_cna_success(inputs)
	if (locale === "fr") return fr_ticket_action_cna_success(inputs)
	return de_ticket_action_cna_success(inputs)
});